"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.entropyToMnemonic = exports.mnemonicToEntropy = exports.mnemonicToSeed = exports.validateMnemonic = exports.generateMnemonic = void 0;
const bip39 = __importStar(require("ethereum-cryptography/bip39"));
const english_1 = require("ethereum-cryptography/bip39/wordlists/english");
const utils_1 = require("ethereum-cryptography/utils");
const bytes_1 = require("../utils/bytes");
function generateMnemonic(strength = 128) {
    return bip39.generateMnemonic(english_1.wordlist, strength);
}
exports.generateMnemonic = generateMnemonic;
function validateMnemonic(mnemonic) {
    return bip39.validateMnemonic(mnemonic, english_1.wordlist);
}
exports.validateMnemonic = validateMnemonic;
function mnemonicToSeed(mnemonic, password = '') {
    return (0, utils_1.toHex)(bip39.mnemonicToSeedSync(mnemonic, password));
}
exports.mnemonicToSeed = mnemonicToSeed;
function mnemonicToEntropy(mnemonic) {
    return (0, utils_1.toHex)(bip39.mnemonicToEntropy(mnemonic, english_1.wordlist));
}
exports.mnemonicToEntropy = mnemonicToEntropy;
function entropyToMnemonic(entropy) {
    return bip39.entropyToMnemonic((0, bytes_1.hexStringToBytes)(entropy), english_1.wordlist);
}
exports.entropyToMnemonic = entropyToMnemonic;
